import { IContractAddEditRequest } from '../../../../model/scp/contract/request/contract-add-edit-request';
import { ITableResponse } from '../../../../model/scp/purchase/response/tables-response';
import { IUnidEntityResponse } from '../../../../model/scp/entity/response/unid-entity-response';
import { IPurchasePagedResponse } from '../../../../model/scp/purchase/response/purchase-paged-response';
import { IFileAddRequest } from '../../../../model/scp/base/request/file-add-request';

export type ContractCreateEditState = {
    contractId?: string;
    contractRequest: IContractAddEditRequest;
    typeContract: ITableResponse[];
    categoryProcess: ITableResponse[];
    typeDocument: ITableResponse[];
    unidEntity: IUnidEntityResponse[];
    purchases: IPurchasePagedResponse[];
    files: IFileAddRequest[];
    file?: File;
    tabIndex: number;
    showValidationErrors: boolean;
};

export enum ACTION_TYPES {
    setContractId = 'setContractId',
    setContractRequest = 'setContractRequest',
    updateContractRequest = 'updateContractRequest',
    setTypeContract = 'setTypeContract',
    setCategoryProcess = 'setCategoryProcess',
    setTypeDocument = 'setTypeDocument',
    setUnidEntity = 'setUnidEntity',
    setPurchases = 'setPurchases',
    setFiles = 'setFiles',
    setFile = 'setFile',
    setTabIndex = 'setTabIndex',
    setShowValidationErrors = 'setShowValidationErrors',
    resetState = 'resetState',
}

export const ContractCreateEditReducer = (
    state: ContractCreateEditState,
    action: any
): ContractCreateEditState => {
    const { type, payload } = action;

    switch (type) {
        case ACTION_TYPES.setContractId:
            return { ...state, contractId: payload };

        case ACTION_TYPES.setContractRequest:
            return { ...state, contractRequest: payload };

        case ACTION_TYPES.updateContractRequest:
            return {
                ...state,
                contractRequest: { ...state.contractRequest, ...payload }
            };

        case ACTION_TYPES.setTypeContract:
            return { ...state, typeContract: payload };

        case ACTION_TYPES.setCategoryProcess:
            return { ...state, categoryProcess: payload };

        case ACTION_TYPES.setTypeDocument:
            return { ...state, typeDocument: payload };

        case ACTION_TYPES.setUnidEntity:
            return { ...state, unidEntity: payload };

        case ACTION_TYPES.setPurchases:
            return { ...state, purchases: payload };

        case ACTION_TYPES.setFiles:
            return { ...state, files: payload };

        case ACTION_TYPES.setFile:
            return { ...state, file: payload };

        case ACTION_TYPES.setTabIndex:
            return { ...state, tabIndex: payload };

        case ACTION_TYPES.setShowValidationErrors:
            return { ...state, showValidationErrors: payload };

        case ACTION_TYPES.resetState:
            return {
                contractId: undefined,
                contractRequest: { yearContract: payload } as IContractAddEditRequest,
                typeContract: state.typeContract,
                categoryProcess: state.categoryProcess,
                typeDocument: state.typeDocument,
                unidEntity: state.unidEntity,
                purchases: state.purchases,
                files: [],
                file: undefined,
                tabIndex: 0,
                showValidationErrors: false,
            };

        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
